"use client";

import Image from "next/image";
import { AiFillStar } from "react-icons/ai";
import { FaQuoteLeft } from "react-icons/fa";
import { COLORS } from "@/lib/design-tokens";

interface Testimonial {
  id: number;
  name: string;
  role: string;
  image: string;
  rating: number;
  text: string;
}

interface TestimonialCardProps {
  review: Testimonial;
}

export default function TestimonialCard({ review }: TestimonialCardProps) {
  return (
    <div className="bg-white p-8 md:p-10 border border-gray-100 h-full flex flex-col relative rounded-sm hover:shadow-lg transition-all duration-300 group">
      {/* Icon Quote */}
      <FaQuoteLeft
        size={64}
        className="absolute top-6 right-6 text-gray-100 group-hover:text-brand-gold/10 transition-colors duration-300"
      />

      {/* Stars */}
      <div className="flex gap-1 mb-6 relative z-10">
        {[...Array(review.rating)].map((_, i) => (
          <AiFillStar
            key={i}
            size={14}
            className="text-brand-gold"
          />
        ))}
      </div>

      {/* Text */}
      <p className="text-gray-500 font-light leading-relaxed mb-8 italic relative z-10 line-clamp-6">
        "{review.text}"
      </p>

      {/* Profile */}
      <div className="flex items-center gap-4 mt-auto relative z-10">
        <div className="relative w-12 h-12 rounded-full overflow-hidden border border-gray-100">
          <Image
            src={review.image}
            alt={review.name}
            fill
            className="object-cover"
            sizes="48px"
          />
        </div>
        <div>
          <h4 className="font-bold text-sm text-brand-charcoal uppercase tracking-wider group-hover:text-brand-gold transition-colors">
            {review.name}
          </h4>
          <p className="text-xs text-gray-400 font-medium">
            {review.role}
          </p>
        </div>
      </div>
    </div>
  );
}
